import type { Submission } from "@/types";
import { getLevel } from "@/types";
import { Card } from "../ui/Card";
import { Badge } from "../ui/Badge";
import { ProgressBar } from "../ui/ProgressBar";

interface Props {
  submission: Submission;
}

export function ResultsCard({ submission }: Props) {
  const score = submission.scoreTotale ?? 0;
  const max = submission.scoreMassimo ?? 0;
  const pct = submission.percentuale ?? (max > 0 ? Math.round((score / max) * 100) : 0);
  const level = getLevel(score, max);

  const sezioni = Object.entries(submission.sezioniScore ?? {});

  return (
    <Card className="space-y-6">
      <header className="text-center space-y-2">
        <div className="text-6xl">{level.emoji}</div>
        <Badge color={level.color}>{level.label}</Badge>
        <p className="text-secondary text-sm">{level.description}</p>
      </header>

      <div className="bg-bg border border-border rounded-xl p-5 text-center">
        <div className="text-5xl font-mono text-primary">
          {score}<span className="text-secondary">/{max}</span>
        </div>
        <div className="text-sm text-secondary mt-1 font-mono">
          {pct}% di risposte corrette
        </div>
        <ProgressBar value={Number(pct)} color={level.color} className="mt-4" />
      </div>

      {sezioni.length > 0 && (
        <div className="space-y-3">
          <h3 className="text-xs uppercase tracking-wider font-mono text-secondary">
            Per modulo
          </h3>
          {sezioni.map(([nome, s]) => {
            const sPct = s.total > 0 ? Math.round((s.score / s.total) * 100) : 0;
            return (
              <div key={nome} className="space-y-1.5">
                <div className="flex justify-between items-baseline">
                  <span className="text-primary">{nome}</span>
                  <span className="text-secondary font-mono text-sm">
                    {s.score}/{s.total} · {sPct}%
                  </span>
                </div>
                <ProgressBar value={sPct} />
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
}
